var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5Full(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 167,
    viewBox: "0 0 150 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.8371 45.4399C92.472 45.4399 86.8897 46.1269 82.0975 47.51L82.7701 37.421H140.738H141.238V36.921V1.78467V1.28467H140.738H47.5418H47.0724L47.0428 1.75312L41.9697 81.9842L41.9361 82.5157H42.4687H76.2897H76.518L76.6676 82.3432C79.8097 78.7177 84.2932 76.8789 90.1939 76.8789C95.5214 76.8789 99.4237 78.0112 101.99 80.1892C104.54 82.3538 105.853 85.6236 105.853 90.0952C105.853 94.2476 104.636 97.4908 102.246 99.8834C99.8619 102.146 96.4334 103.312 91.885 103.312C87.1971 103.312 83.4912 102.263 80.7206 100.215C77.9639 98.1776 76.6018 95.5068 76.6018 92.162V91.6596L76.0994 91.6621L37.3931 91.85L36.8955 91.8524V92.35V94.6047C36.8955 108.52 41.9011 119.506 51.9274 127.501L51.9305 127.504C61.9427 135.361 75.7191 139.26 93.2002 139.26C110.182 139.26 123.764 135.486 133.898 127.886C144.076 120.253 149.129 108.497 149.129 92.7257C149.129 78.4398 144.128 66.9603 134.113 58.3389C124.247 49.7386 112.48 45.4399 98.8371 45.4399Z",
    stroke: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8196_8426",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 1,
    width: 112,
    height: 138
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8371 45.9399C112.366 45.9399 124.015 50.1989 133.786 58.7168C143.681 67.2347 148.629 78.571 148.629 92.7257C148.629 108.384 143.619 119.97 133.598 127.486C123.577 135.002 110.111 138.76 93.2002 138.76C75.7887 138.76 62.135 134.877 52.2392 127.11C42.3434 119.219 37.3955 108.384 37.3955 94.6047V92.35L76.1018 92.162C76.1018 95.6694 77.5424 98.4878 80.4234 100.617C83.3045 102.747 87.125 103.812 91.885 103.812C96.5197 103.812 100.09 102.622 102.595 100.242C105.1 97.7363 106.353 94.3542 106.353 90.0952C106.353 80.951 100.967 76.3789 90.1939 76.3789C84.1813 76.3789 79.5466 78.2578 76.2897 82.0157H42.4687L47.5418 1.78467H140.738V36.921H82.3024L81.5508 48.1947C86.436 46.6915 92.1981 45.9399 98.8371 45.9399Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8196_8426)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8196_8426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.604 76.8259C39.2429 73.1939 40.2976 61.0035 39.146 54.8398C37.6409 46.2229 35.2099 27.0844 37.5262 19.4662C40.4217 9.94333 58.0836 2.39445 68.2485 -1.51836C78.4135 -5.43118 106.52 -3.27691 112.916 3.52935C119.312 10.3356 114.211 29.7951 106.624 39.3192C99.0365 48.8433 88.5918 39.1402 86.2458 39.1408C83.8998 39.1415 72.0325 41.7207 69.32 47.2874C66.6075 52.8542 65.278 69.4146 60.8182 77.3739C56.3584 85.3331 53.965 80.4578 46.604 76.8259Z",
    fill: "#3538CD"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2212 28.1008L47.0287 1.23438",
    stroke: "url(#paint0_linear_8196_8426)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.948 28.4538L140.756 1.5874",
    stroke: "url(#paint1_linear_8196_8426)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M105.561 64.2834L141.368 37.417",
    stroke: "url(#paint2_linear_8196_8426)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0615 64.5149L82.8691 37.6484",
    stroke: "url(#paint3_linear_8196_8426)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.375 74.0232L82.1825 47.1567",
    stroke: "url(#paint4_linear_8196_8426)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.211 104.787L147.018 77.9209",
    stroke: "url(#paint5_linear_8196_8426)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4165 154.41L134.224 127.544",
    stroke: "url(#paint6_linear_8196_8426)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6831 118.721L76.4907 91.855",
    stroke: "url(#paint7_linear_8196_8426)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 118.677L36.8075 91.8105",
    stroke: "url(#paint8_linear_8196_8426)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37451 109.106L42.1821 82.2397",
    stroke: "url(#paint9_linear_8196_8426)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6831 109.392L76.4907 82.5259",
    stroke: "url(#paint10_linear_8196_8426)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_8196_8426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0475 72.7822C76.576 72.7822 88.2254 77.0412 97.996 85.5591C107.892 94.077 112.84 105.413 112.84 119.568C112.84 135.226 107.829 146.813 97.8081 154.329C87.787 161.844 74.3212 165.602 57.4107 165.602C39.9991 165.602 26.3454 161.719 16.4496 153.953C6.55385 146.061 1.60596 135.226 1.60596 121.447V119.192L40.3123 119.004C40.3123 122.512 41.7528 125.33 44.6339 127.46C47.5149 129.589 51.3354 130.654 56.0954 130.654C60.7302 130.654 64.3002 129.464 66.8054 127.084C69.3107 124.579 70.5633 121.196 70.5633 116.937C70.5633 107.793 65.177 103.221 54.4044 103.221C48.3917 103.221 43.757 105.1 40.5002 108.858H6.67912L11.7523 28.627H104.948V63.7633H46.5128L45.7612 75.037C50.6465 73.5338 56.4086 72.7822 63.0475 72.7822Z",
    fill: "white",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0475 72.2822C56.6824 72.2822 51.1002 72.9692 46.308 74.3523L46.9806 64.2633H104.948H105.448V63.7633V28.627V28.127H104.948H11.7523H11.2829L11.2533 28.5954L6.18011 108.826L6.1465 109.358H6.67912H40.5002H40.7285L40.878 109.185C44.0201 105.56 48.5036 103.721 54.4044 103.721C59.7318 103.721 63.6342 104.853 66.2 107.031C68.7502 109.196 70.0633 112.466 70.0633 116.937C70.0633 121.09 68.8464 124.333 66.4565 126.726C64.0724 128.988 60.6438 130.154 56.0954 130.154C51.4075 130.154 47.7017 129.105 44.931 127.058C42.1743 125.02 40.8123 122.349 40.8123 119.004V118.502L40.3098 118.504L1.60353 118.692L1.10596 118.695V119.192V121.447C1.10596 135.363 6.11157 146.348 16.1379 154.344L16.141 154.346C26.1532 162.204 39.9295 166.102 57.4107 166.102C74.392 166.102 87.9747 162.329 98.1081 154.729C108.286 147.095 113.34 135.34 113.34 119.568C113.34 105.282 108.339 93.8026 98.3233 85.1811C88.4577 76.5809 76.6905 72.2822 63.0475 72.2822Z",
    stroke: "#111517"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8196_8426",
    x: -37.9783,
    y: -78.0095,
    width: 228.346,
    height: 234.223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.2741,
    result: "effect1_foregroundBlur_8196_8426"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_8196_8426",
    x: -4.76246,
    y: 22.2585,
    width: 123.971,
    height: 149.712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.68421
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_8196_8426"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_8196_8426",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8196_8426",
    x1: 12.4164,
    y1: 28.1007,
    x2: 47.0287,
    y2: 1.23437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8196_8426",
    x1: 106.143,
    y1: 28.4538,
    x2: 140.756,
    y2: 1.5874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8196_8426",
    x1: 106.756,
    y1: 64.2833,
    x2: 141.368,
    y2: 37.417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8196_8426",
    x1: 48.2567,
    y1: 64.5148,
    x2: 82.869,
    y2: 37.6484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8196_8426",
    x1: 47.5702,
    y1: 74.0231,
    x2: 82.1825,
    y2: 47.1567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8196_8426",
    x1: 112.406,
    y1: 104.787,
    x2: 147.018,
    y2: 77.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8196_8426",
    x1: 99.6117,
    y1: 154.41,
    x2: 134.224,
    y2: 127.544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8196_8426",
    x1: 41.8783,
    y1: 118.721,
    x2: 76.4906,
    y2: 91.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8196_8426",
    x1: 2.19517,
    y1: 118.677,
    x2: 36.8075,
    y2: 91.8105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8196_8426",
    x1: 7.56968,
    y1: 109.106,
    x2: 42.182,
    y2: 82.2397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8196_8426",
    x1: 41.8783,
    y1: 109.392,
    x2: 76.4906,
    y2: 82.5259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F9F9F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Full);
export default __webpack_public_path__ + "static/media/5__full.7c48b2c824d458dc50973da2fa2d28ec.svg";
export { ForwardRef as ReactComponent };